import React from 'react'
import styled from 'styled-components'

const Container = styled.span`
  text-align: center;
  font-size: 24px;
  font-weight: 100;
  color: white;
`

const Loading = () => <Container>Loading...</Container>

Loading.propTypes = {}

export default Loading
